import {
  AppkitDropdownItem,
  getAppkitDropdownSelection,
  mapToAppkitDropdownItems,
  setDropdownAriaLabel,
  syncAppkitDropdownSelection
} from '../../shared/utils/appkit-dropdown.util';

export function refreshNamedDropdown(
  component: any,
  sourceKey: string,
  modelKey: string,
  labelKey: string = 'label',
  valueKey?: string,
  itemKeySuffix: string = 'Item',
  viewKeySuffix: string = 'View'
): void {
  const viewKey = `${sourceKey}${viewKeySuffix}`;
  const itemKey = `${modelKey}${itemKeySuffix}`;
  component[viewKey] = mapToAppkitDropdownItems(component[sourceKey], labelKey, valueKey);
  component[itemKey] = syncAppkitDropdownSelection(
    component[viewKey],
    component[modelKey],
    labelKey,
    valueKey
  );
}

export function handleNamedDropdownSelect(
  event: any,
  component: any,
  itemKey: string,
  modelKey: string,
  labelKey: string = 'label',
  valueKey?: string,
  viewKey?: string,
  afterChange?: () => void
): void {
  const selected = getAppkitDropdownSelection(event);
  if (selected) {
    component[itemKey] = selected;
    if (valueKey) {
      component[modelKey] = component[viewKey || '']?.find((item: AppkitDropdownItem) => item.value === selected.value)
        ?? sourceFromView(component, viewKey).find((item: any) => String(item?.[valueKey]) === String(selected.value))
        ?? selected;
    } else {
      component[modelKey] = selected;
    }
  }
  afterChange?.call(component);
}

function sourceFromView(component: any, viewKey?: string): any[] {
  if (!viewKey || !viewKey.endsWith('View')) {
    return [];
  }
  const sourceKey = viewKey.slice(0, -4);
  return component[sourceKey] || [];
}

export function setFormDropdownAriaLabel(item: any, contextLabel: string): string {
  return setDropdownAriaLabel(item, contextLabel);
}

export function onDropdownSelectItem(event: any, component: any, itemKey: string): void {
  const selected = getAppkitDropdownSelection(event);
  if (selected) {
    component[itemKey] = selected;
  }
}
